import React, { useEffect, useState } from "react";
import styles from "./ProjectDetailsPage.module.scss";
import Carousel from "./components/Carousel";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProjectCard from "./components/ProjectsFilters/ProjectCard";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getProject } from "./utils/getProjects";
import LoadingScreen from "./components/LoadingScreen";
import NextArrow from "./components/NextArrow";
import PrevArrow from "./components/PrevArrow";

export default function ProjectDetailsPage() {
  const { locale, id } = useParams();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [project, setProject] = useState(null);
  const [data, setData] = useState(null);

  const projectsSettings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    autoplay: false,
    speed: 500,
    dots: false,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    className: "product-slider",
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          rows: 1,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          rows: 1,
        },
      },
    ],
  };

  useEffect(() => {
    setLoading(true);
    if (locale) i18n.changeLanguage(locale);
    async function startFetch() {
      setProject(null);
      const res = await getProject(locale, id);
      setProject(res.project_detail);
      setData(res.company_info[0]);
      setLoading(false);
    }
    startFetch();
  }, [locale]);

  if (loading) {
    return <LoadingScreen />;
  }
  return (
    <>
      <Navbar light={true} />
      <main>
        <img
          className={styles.projectDetailsImage}
          src={project?.thumbnail}
          alt="hero image"
        />
        <div className={styles.projectDetails}>
          <div className={styles.projectDetailsHeader}>
            <div className={styles.projectDetailsContent}>
              <h1>{project?.title}</h1>
              <p>{project?.body}</p>
            </div>

            <div className={styles.info}>
              <div>
                <h3>{t("projects_details.location")}</h3>
                <p>{project?.location}</p>
              </div>
              <div>
                <h3>{t("projects_details.completed")}</h3>
                <p>{project?.completed}</p>
              </div>
              <div>
                <h3>{t("projects_details.project_type")}</h3>
                <p>{project?.type.title}</p>
              </div>
            </div>
          </div>
          <div className={styles.carouselWrapper}>
            <Carousel sliderSettings={projectsSettings}>
              {project?.images.map((image, index) => {
                return (
                  <div className={styles.imgWrapper}>
                    <img key={index} src={image.image} alt="" />;
                  </div>
                );
              })}
            </Carousel>
          </div>
        </div>
        <div className={styles.withoutBg}>
          <article>
            <h5>{project?.description}</h5>
          </article>
          <div className={styles.moreProjects}>
            <h5>{t("projects_details.explore_more")}</h5>
            <Carousel sliderSettings={projectsSettings}>
              {project?.explore_more_projects.map((project) => {
                return <ProjectCard key={project.id} project={project} />;
              })}
            </Carousel>
          </div>
        </div>
      </main>
      <Footer data={data} />
    </>
  );
}
